var map = {
	"./1998/trending/large.jpg": 7952,
	"./beyond-earth/trending/large.jpg": 6570,
	"./bottom-gear/trending/large.jpg": 9061,
	"./dark-side-of-the-moon/trending/large.jpg": 4235,
	"./undiscovered-cities/trending/large.jpg": 6922
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3796;